(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('biaProfileCriticalityViewController', Controller);

    Controller.$inject = ['$scope', 'biaProfileService'];

    function Controller($scope, biaProfileService) {

        $scope.cvCtxt = {
            isLoading: true,
            hasData: false
        };

        init();

        function init() {
            var biaProfileId = $scope.boxModel.BIAProfileID;

            biaProfileService
                .getCriticalityView(biaProfileId)
                .then(function (data) {
                    if (!data) {
                        $scope.cvCtxt.hasData = false;
                        return;
                    }
                    $scope.cvCtxt.hasData = true;
                    buildRadarChart(data.Radar);
                    buildPriorityChart(data.PriorityCounts);
                    buildMtpdDistributionChart(data.MtpdDistribution);
                    buildDependencyHeatmap(data.DependencyHeatmap);
                })
                .catch(function () {
                    $scope.cvCtxt.hasData = false;
                })
                .finally(function () {
                    $scope.cvCtxt.isLoading = false;
                });
        }

        // --- Radar Chart: Impact Dimensions ---
        // Radar: { FinancialCount, OperationalCount, ComplianceCount, MaxFinancialImpact, ... }
        function buildRadarChart(radar) {
            if (!radar) return;

            $scope.radarLabels = ['Financial', 'Operational', 'Compliance'];
            $scope.radarData = [[
                radar.FinancialCount || 0,
                radar.OperationalCount || 0,
                radar.ComplianceCount || 0
            ]];
            $scope.radarOptions = {
                scale: {
                    ticks: { beginAtZero: true, stepSize: 1 },
                    pointLabels: { fontSize: 13 }
                },
                legend: { display: false }
            };
        }

        // --- Bar Chart: Priority Counts ---
        // PriorityCounts: [{ PriorityName, SortOrder, Count }]
        function buildPriorityChart(priorities) {
            if (!priorities || !priorities.length) return;

            var sorted = _.sortBy(priorities, 'SortOrder');
            $scope.priorityLabels = _.map(sorted, function (p) {
                return p.PriorityName.replace('Continuity Priority ', 'P');
            });
            $scope.priorityData = _.map(sorted, 'Count');
            $scope.priorityColors = ['#d9534f', '#f0ad4e', '#5bc0de', '#5cb85c', '#777'].slice(0, sorted.length);
            $scope.priorityOptions = {
                legend: { display: false },
                scales: {
                    yAxes: [{ ticks: { beginAtZero: true, stepSize: 1 } }]
                }
            };
        }

        // --- Bar Chart: MTPD Distribution ---
        // MtpdDistribution: { Under2h, From2hTo8h, From8hTo24h, Over24h, NoMtpd }
        function buildMtpdDistributionChart(mtpd) {
            if (!mtpd) return;

            $scope.mtpdLabels = ['<2h', '2-8h', '8-24h', '>24h', 'N/A'];
            $scope.mtpdData = [
                mtpd.Under2h || 0,
                mtpd.From2hTo8h || 0,
                mtpd.From8hTo24h || 0,
                mtpd.Over24h || 0,
                mtpd.NoMtpd || 0
            ];
            $scope.mtpdColors = ['#5cb85c', '#5bc0de', '#f0ad4e', '#d9534f', '#999'];
            $scope.mtpdOptions = {
                legend: { display: false },
                scales: {
                    yAxes: [{ ticks: { beginAtZero: true, stepSize: 1 } }]
                }
            };
        }

        // --- Bar Chart: Dependency Heatmap ---
        // DependencyHeatmap: [{ DependencyName, Count }]
        function buildDependencyHeatmap(deps) {
            if (!deps || !deps.length) return;

            $scope.depLabels = _.map(deps, 'DependencyName');
            $scope.depData = _.map(deps, 'Count');
            $scope.depColors = ['#337ab7'];
            $scope.depOptions = {
                legend: { display: false },
                scales: {
                    yAxes: [{ ticks: { beginAtZero: true, stepSize: 1 } }],
                    xAxes: [{ ticks: { autoSkip: false, maxRotation: 45 } }]
                }
            };
        }
    }
})();
